import Phaser from 'phaser';
import { GAME_WIDTH } from '../config';
import { mountShell, paintShellBackdrop } from '../ui/shellUi';

/**
 * Quests shell tab — simple placeholder only.
 */
export class QuestsScene extends Phaser.Scene {
  constructor() {
    super('Quests');
  }

  create(): void {
    paintShellBackdrop(this, 0x1a1e28);
    const bounds = mountShell(this, 'quests');
    const cx = GAME_WIDTH / 2;
    const mid = bounds.top + bounds.height / 2;

    this.add
      .text(cx, mid - 40, 'Quests', {
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontSize: '28px',
        color: '#e8d5a3',
      })
      .setOrigin(0.5);

    this.add
      .rectangle(cx, mid + 20, 280, 80, 0x1c2438)
      .setStrokeStyle(1, 0x4a5168);

    this.add
      .text(
        cx,
        mid + 20,
        'Quest board placeholder.\nNo quests implemented yet.',
        {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '13px',
          color: '#9aa3c0',
          align: 'center',
          lineSpacing: 6,
        },
      )
      .setOrigin(0.5);
  }
}
